/* Fr33form space-time mesh: a rippled grid seen from near the horizon, drawn behind text sections.
   Ported from the Koza page's quote breaks. Hosts: the home page's quote/manifesto/press sections,
   plus anything marked data-mesh. Ink colour follows the page's --ink so dark mode just works. */
(function () {
  if (window.__frMesh) return; window.__frMesh = true;
  var hosts = [].slice.call(document.querySelectorAll('.epigraph, .manifesto, .press, .opener > .wrap, .guarantee, [data-mesh]'));
  if (!hosts.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var st = document.createElement('style');
  st.textContent =
    '.fr-mesh-host{position:relative;overflow:hidden}' +
    '.fr-mesh-host>*:not(canvas.fr-mesh){position:relative;z-index:1}' +
    'canvas.fr-mesh{position:absolute;inset:0;width:100%;height:100%;z-index:0;pointer-events:none;' +
    '-webkit-mask-image:radial-gradient(ellipse 66% 100% at 50% 60%,#000 26%,transparent 100%);' +
    'mask-image:radial-gradient(ellipse 66% 100% at 50% 60%,#000 26%,transparent 100%)}';
  document.head.appendChild(st);

  function ink() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--ink').trim(), r = 23, g = 26, b = 22, m;
    if ((m = /^#([0-9a-f]{3})$/i.exec(v))) v = '#' + m[1].replace(/./g, '$&$&');
    if ((m = /^#([0-9a-f]{6})$/i.exec(v))) { r = parseInt(m[1].slice(0, 2), 16); g = parseInt(m[1].slice(2, 4), 16); b = parseInt(m[1].slice(4, 6), 16); }
    var light = (r * 299 + g * 587 + b * 114) / 1000 > 128;
    return { rgb: r + ',' + g + ',' + b, k: light ? 0.2 : 0.3 };
  }

  var D0 = 1, D1 = 7.5, CAM = 1, live = [], raf = 0, t0 = performance.now(), col = ink();

  hosts.forEach(function (h) {
    h.classList.add('fr-mesh-host');
    var c = document.createElement('canvas');
    c.className = 'fr-mesh'; c.setAttribute('aria-hidden', 'true');
    h.insertBefore(c, h.firstChild);
    h._c = c;
  });

  function setup(h) {
    var c = h._c, dpr = Math.min(window.devicePixelRatio || 1, 2);
    h._w = c.clientWidth; h._h = c.clientHeight;
    c.width = Math.round(h._w * dpr); c.height = Math.round(h._h * dpr);
    h._x = c.getContext('2d'); h._x.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  // height of the fabric at world (x, depth d): two slow swells plus a dip that swings like a pendulum bob
  function ht(x, d, t) {
    var wx = Math.sin(t * 0.32) * 5.5;
    return 0.13 * Math.sin(x * 0.9 + d * 0.8 - t * 0.5) + 0.09 * Math.sin(x * 0.45 - d * 0.55 + t * 0.3)
      - 0.42 * Math.exp(-((x - wx) * (x - wx) + (d - 4.2) * (d - 4.2)) / (2 * 2.1 * 2.1));
  }

  function draw(h, t) {
    var ctx = h._x, W = h._w, H = h._h; if (!ctx || !W || !H) return;
    var hy = H * 0.3, F = (H - hy) * D0 / CAM, cx = W / 2;
    var X = W / 2 * D1 / F * 1.15, dx = 0.55, x, d, i, n, p, q, s;
    ctx.clearRect(0, 0, W, H); ctx.lineWidth = 1;
    function pt(wx, wd) { s = F / wd; return [cx + wx * s, hy + (CAM - ht(wx, wd, t)) * s]; }
    function alpha(wd) { return col.k * Math.pow(1 - (wd - D0) / (D1 - D0), 1.3); }
    // lines running away from us, in short runs so they fade toward the horizon
    for (x = -X; x <= X; x += dx) {
      p = pt(x, D0);
      for (d = D0 + 0.35; d <= D1 + 0.01; d += 0.35) {
        q = pt(x, d);
        ctx.strokeStyle = 'rgba(' + col.rgb + ',' + alpha(d - 0.175).toFixed(3) + ')';
        ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(q[0], q[1]); ctx.stroke(); p = q;
      }
    }
    // lines running across, bunching toward the horizon
    for (d = D0, n = 0; d <= D1; d *= 1.2, n++) {
      ctx.strokeStyle = 'rgba(' + col.rgb + ',' + alpha(d).toFixed(3) + ')';
      ctx.beginPath();
      for (x = -X, i = 0; x <= X; x += dx / 2, i++) { p = pt(x, d); i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]); }
      ctx.stroke();
    }
  }

  function all() { col = ink(); hosts.forEach(function (h) { setup(h); draw(h, 3); }); }
  function loop(now) { var t = (now - t0) / 1000; live.forEach(function (h) { draw(h, t); }); raf = live.length ? requestAnimationFrame(loop) : 0; }

  all();
  window.addEventListener('resize', all);
  window.addEventListener('load', all);
  if (window.matchMedia) { var mq = window.matchMedia('(prefers-color-scheme: dark)'); (mq.addEventListener ? mq.addEventListener('change', all) : mq.addListener && mq.addListener(all)); }

  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        var i = live.indexOf(e.target);
        if (e.isIntersecting) { if (i < 0) live.push(e.target); } else if (i >= 0) live.splice(i, 1);
      });
      if (live.length && !raf) raf = requestAnimationFrame(loop);
    }, { threshold: 0.02 });
    hosts.forEach(function (h) { io.observe(h); });
  }
})();
